import { defineField, defineType } from 'sanity'

export default defineType({
  title: 'Testimonials',
  name: 'testimonials',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
      initialValue: 'What The Experts Say',
    }),
    defineField({
      title: 'Testimonials',
      name: 'testimonials',
      type: 'array',
      of: [{ type: 'testimonial' }],
    }),
  ],
})